import { CreateCollectionCampaignSchema, UpdateCollectionCampaignSchema } from '@repo/contracts';
import { withRetry } from '../utils/retry.js';

export class CollectionCampaignService {
    constructor(api) {
        this.api = api;
    }

    async list() {
        const response = await withRetry(() => this.api.getAll(), { maxRetries: 2 });
        return { success: true, data: response.data || [] };
    }

    async targets() {
        const response = await withRetry(() => this.api.targets(), { maxRetries: 2 });
        return { success: true, data: response.data || [] };
    }

    async create(data) {
        const parsed = CreateCollectionCampaignSchema.parse(data);
        const response = await this.api.create(parsed);
        return { success: true, data: response.data };
    }

    async update(id, data) {
        const parsed = UpdateCollectionCampaignSchema.parse(data);
        const response = await this.api.update(id, parsed);
        return { success: true, data: response.data };
    }

    async launch(id) {
        const response = await this.api.launch(id);
        return { success: true, data: response.data };
    }

    async resync(id) {
        const response = await this.api.resync(id);
        return { success: true, data: response.data };
    }

    async cancel(id) {
        const response = await this.api.cancel(id);
        return { success: true, data: response.data };
    }

    async remind(id) {
        const response = await this.api.remind(id);
        return { success: true, data: response.data };
    }

    async progress(id) {
        const response = await withRetry(() => this.api.progress(id), { maxRetries: 2 });
        return { success: true, data: response.data };
    }

    async searchRecords(assignmentId, q) {
        const response = await this.api.searchRecords(assignmentId, q);
        return { success: true, data: response.data || [] };
    }

    async createRecord(assignmentId, body) {
        const response = await this.api.createRecord(assignmentId, body);
        return { success: true, data: response.data };
    }

    async listRecords(assignmentId) {
        const response = await this.api.listRecords(assignmentId);
        return { success: true, data: response.data || [] };
    }

    async updateRecord(assignmentId, recordId, record) {
        const response = await this.api.updateRecord(assignmentId, recordId, { record });
        return { success: true, data: response.data };
    }

    async completeAssignment(assignmentId) {
        const response = await this.api.completeAssignment(assignmentId);
        return { success: true, data: response.data };
    }

    async linkRecord(assignmentId, entityId) {
        const response = await this.api.linkRecord(assignmentId, entityId);
        return { success: true, data: response.data };
    }
}
